import { ArrowLeft, Check, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { RegulatedNote } from "../../components/Cards";
import { usePageHeader } from "../../components/shell/PageHeaderContext";
import { Spinner } from "../../components/Spinner";
import { formatTimestamp } from "../../lib/format";
import { customerStatusLabel, formatMxn, formatPhone } from "../../lib/loans";
import { useLoanConfig, useMyLoanApplication } from "../../lib/queries";
import { LoanStatusTag } from "./LoanShared";

const STATUS_COPY: Record<string, string> = {
  submitted: "Un ejecutivo de Peso a Peso se pondrá en contacto contigo con la decisión y, en su caso, las condiciones disponibles.",
  in_review: "Peso a Peso está revisando tu solicitud. Te contactará al correo y teléfono registrados con la decisión.",
  approved: "Peso a Peso aprobó tu solicitud. Un ejecutivo te contactará para formalizar el crédito y explicarte las condiciones finales.",
  rejected: "En esta ocasión Peso a Peso no aprobó tu solicitud. Tu Wallet Libre sigue disponible para ahorrar hacia tu próximo viaje."
};

/** "Ver estatus de mi solicitud" — folio, status and the summary the applicant submitted. */
export function LoanStatusPage({ id }: { id: string | undefined }) {
  const application = useMyLoanApplication(id);
  const config = useLoanConfig();
  usePageHeader(application.data ? `Solicitud ${application.data.folio}` : "Solicitud de crédito", "Viaja ahora · paga después");
  if (application.isLoading) return <div className="page-state"><Spinner label="Cargando" /></div>;
  if (application.isError || !application.data) {
    return <div className="page-state error"><strong>No encontramos esta solicitud</strong><Link className="secondary-button" to="/credito">Volver</Link></div>;
  }
  const item = application.data;
  return (
    <div className="page-container">
      <Link to="/credito" className="back-button"><ArrowLeft size={16} aria-hidden="true" /> Viaja hoy, paga después</Link>
      <div className="loan-done-grid">
        <section className={`loan-done-hero ${item.status}`}>
          <span className="loan-done-icon"><Check size={28} strokeWidth={2.4} aria-hidden="true" /></span>
          <h2>{customerStatusLabel(item.status)}</h2>
          <p>{STATUS_COPY[item.status]}</p>
          {item.decisionNote && <blockquote className="loan-decision-note"><span>Mensaje de Peso a Peso</span>{item.decisionNote}</blockquote>}
          <Link to="/wallet" className="primary-button loan-cta waikiki">Volver a mi Wallet</Link>
        </section>
        <aside className="card loan-folio-card">
          <span className="rail-title">Folio de solicitud</span>
          <strong className="loan-folio" translate="no">{item.folio}</strong>
          <LoanStatusTag status={item.status} />
          <dl className="review-list loan-review">
            <div><dt>Monto solicitado</dt><dd translate="no">{formatMxn(item.amount)}</dd></div>
            <div><dt>Plazo preferido</dt><dd>{item.termMonths} meses</dd></div>
            <div><dt>CURP</dt><dd translate="no">{item.curpMasked}</dd></div>
            <div><dt>Constancia fiscal</dt><dd className="ok"><FileText size={13} aria-hidden="true" /> {item.document?.originalName ?? "Cargada"}</dd></div>
            <div><dt>Contacto</dt><dd>{item.contact.fullName}<br />{item.contact.email}<br /><span translate="no">{formatPhone(item.contact.phone)}</span></dd></div>
            <div><dt>Enviada</dt><dd>{formatTimestamp(item.submittedAt)}</dd></div>
            {item.decidedAt && <div><dt>Resuelta</dt><dd>{formatTimestamp(item.decidedAt)}</dd></div>}
          </dl>
          <p className="loan-fine">{config.data?.legalNotice ?? "Enviar esta solicitud no garantiza la aprobación de un crédito ni constituye una oferta."}</p>
        </aside>
      </div>
      <RegulatedNote kind="credit" />
    </div>
  );
}
